import React, { useEffect, useState } from "react";
import { Button, Card, Form, notification, Skeleton, Spin } from "antd";


import { useNavigate, useLocation } from "react-router-dom";

import { useSelector } from "react-redux";

import { APIConstants } from "../../../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../../../Hooks/UseStoreUpdaterWithApi";
import { CONFIGURATION_GROUP } from "../../../../../Common/Constants";
import GroupPopup from "../../../../CommonScreens/CreateGroup";
import { GroupGrid } from "../../../../../Common/UIConstants";

const Groups = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [isUpdate, setIsUpdate] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [flowGroupList, setFlowGroupList] = useState([]);
  const [updateRecord, setUpdateRecord] = useState([]);
  const [selectedDeleteData, setSelectedDeleteData] = useState({});
  const [groupModuleList, setGroupModuleList] = useState([]);
  const [reportStatusList, setReportStatusList] = useState([]);

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  const [form] = Form.useForm();

  useEffect(() => {
    fetchFlowGroupList();
    fetchGroupModuleList();
    fetchReportStatusList();
  }, []);

  useEffect(() => {
    if (location.pathname === `${CONFIGURATION_GROUP}/group-add-popup`) {
      setIsAdd(true);
      setIsUpdate(false);
    } else if (
      location.pathname.includes(`${CONFIGURATION_GROUP}/group-update-popup`)
    ) {
      setIsUpdate(true);
      setIsAdd(false);
    } else {
      setIsAdd(false);
      setIsUpdate(false);
    }
  }, [location.pathname]);

  const fetchFlowGroupList = () => {
    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_FLOW_GROUP_DETAILS,
    })
      .then((res) => {
        setFlowGroupList(res);
      })
      .catch((err) => {
        console.error("Error fetching flow group list:", err);
      });
  };

  const fetchGroupModuleList = () => {
    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_APPLICATION_MODULE_DETAILS,
    })
      .then((res) => {
        setGroupModuleList(res);
      })
      .catch((err) => {
        console.error("Error fetching group module list:", err);
      });
  };

  const fetchReportStatusList = () => {
    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_REPORT_STATUS_MASTER_DETAILS,
    })
      .then((res) => {
        setReportStatusList(res);
      })
      .catch((err) => {
        console.error("Error fetching report status list:", err);
      });
  };

  const handleNotification = (msg) => {
    notification.open({
      message: `${msg}`,
    });
  };

  const handleAddPopup = () => {
    navigate(`${CONFIGURATION_GROUP}/group-add-popup`);
  };

  const handleUpdatePopup = (record) => {
    // const recordDetails = record;
    setUpdateRecord(record);
    navigate(`${CONFIGURATION_GROUP}/group-update-popup`);
    // console.log(recordDetails)
  };

  const handleDeletePopup = (record) => {
    setSelectedDeleteData(record.groupID);
  };

  const handleDeleteSubmit = (groupID) => {
    try {
      makeRequest({
        type: APIConstants.DELETE,
        url: `${APIConstants.DELETE_FLOW_GROUP_DETAILS}?GroupID=${groupID}&IsDelete=true`,
      });

      const updatedFlowGroupList = flowGroupList.filter(
        (item) => item.groupID !== groupID
      );
      setFlowGroupList(updatedFlowGroupList);

      handleNotification("Successfully Deleted");
      form.resetFields();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <Card className={`w-full h-auto dark ${isdarkMode ? 'darkmode border-0' : 'whitemode'} `}>
        <div className="flex justify-end">
          <Button onClick={handleAddPopup} className="blue-btn mb-2">
            Add Group
          </Button>
        </div>

        <GroupPopup
          isAdd={isAdd}
          setIsAdd={setIsAdd}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
          flowGroupList={flowGroupList}
          fetchFlowGroupList={fetchFlowGroupList}
          updateRecord={updateRecord}
          title={"Group Details"}
        />

        <div className="overflow-auto">
          <Spin indicator={<Spin size="large" />} spinning={loading}>
            <GroupGrid
              handleUpdatePopup={handleUpdatePopup}
              handleDeletePopup={handleDeletePopup}
              handleDeleteSubmit={handleDeleteSubmit}
              flowGroupList={flowGroupList}
              groupModuleList={groupModuleList}
              reportStatusList={reportStatusList}
            />
          </Spin>
        </div>
      </Card>
    </div>
  );
};

export default Groups;
